import styled from 'styled-components';
import { padding, PaddingProps } from 'styled-system';

export const Wrapper = styled.div<PaddingProps>`
  display: flex;
  place-content: center;
  ${padding};
`;
